document.addEventListener('DOMContentLoaded', function () {
  // Select all the content areas
  const contentAreas = document.querySelectorAll('.st-products-contect-area');

  if (contentAreas.length > 0) {
    let maxHeight = 0;

    // Determine the tallest height
    contentAreas.forEach((area) => {
      const areaHeight = area.offsetHeight;
      if (areaHeight > maxHeight) {
        maxHeight = areaHeight;
      }
    });

    // Apply the tallest height to all elements
    contentAreas.forEach((area) => {
      area.style.height = `${maxHeight}px`;
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('*:not(script):not(style)').forEach(node => {
        if (node.childNodes.length) {
            node.childNodes.forEach(child => {
                if (child.nodeType === Node.TEXT_NODE && (child.textContent.includes('TM') || child.textContent.includes('\u2122'))) {
                    let updatedHTML = child.textContent.replace(/TM(?![a-zA-Z])/g, '<sup style="font-size:0.5em;vertical-align:super">TM</sup>');
                    updatedHTML = updatedHTML.replace(/\u2122/g, '<sup style="font-size:0.5em;vertical-align:super">\u2122</sup>');

                    // Replace text node with the updated HTML wrapped in a span
                    const span = document.createElement('span');
                    span.innerHTML = updatedHTML;
                    child.replaceWith(...span.childNodes);
                }
            });
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;

  // Add active class for desktop submenu
  const desktopSubmenuItems = document.querySelectorAll(".st-header-submenu-item a");
  desktopSubmenuItems.forEach(item => {
    if (item.href === currentUrl) {
      item.parentElement.classList.add("active");
    }
  });

  // Add active class for mobile submenu
  const mobileSubmenuItems = document.querySelectorAll(".st-mobile-submenu-list a");
  mobileSubmenuItems.forEach(item => {
    if (item.href === currentUrl) {
      item.parentElement.classList.add("active");
    }
  });
});



$(document).ready(function () {
  $('.open-info-btn').on('click', function () {
    // Close all open info areas and remove 'active' class from other buttons
    $('.st-all-partners-card-content-info-area').slideUp();
    $('.open-info-btn').removeClass('active');

    // Get the associated info area
    const infoArea = $(this)
      .closest('.st-all-partners-card-content')
      .find('.st-all-partners-card-content-info-area');

    // Toggle the selected info area
    if (infoArea.is(':visible')) {
      // If already open, close it and remove 'active' class
      infoArea.slideUp();
      $(this).removeClass('active');
    } else {
      // Otherwise, open it and add 'active' class
      infoArea.slideDown();
      $(this).addClass('active');
    }
  });
});




document.addEventListener('DOMContentLoaded', function () {
  const openMenu = document.querySelector('.open-menu');
  const mobileMenu = document.querySelector('.st-mobile-menu-block');
  const closeMenu = document.querySelector('.close-menu');
  const innerBlock = document.querySelector('.st-mobile-menu-innerblock'); // Select inner block
  const html = document.documentElement; // Select the HTML element

  if (openMenu && mobileMenu && closeMenu && innerBlock) {
    // Open the mobile menu
    openMenu.addEventListener('click', function () {
      mobileMenu.classList.add('active');
      innerBlock.classList.add('active'); // Add active class to inner block
      html.style.overflowY = 'hidden'; // Prevent vertical scroll when menu is open
    });

    // Close the mobile menu
    closeMenu.addEventListener('click', function () {
      innerBlock.classList.remove('active'); // Remove active class from inner block
      setTimeout(function () {
        mobileMenu.classList.remove('active');
        html.style.overflowY = ''; // Restore vertical scroll when menu is closed
      }, 300); // Delay to ensure smooth transition
    });
  }
});





$(document).ready(function () {
  $('.open-mobile-menu').click(function () {
    // Close all submenus except the one related to this icon
    $('.st-mobile-submenu-list-block')
      .not($(this).closest('.st-mobile-menu-list').next('.st-mobile-submenu-list-block'))
      .slideUp();
    $('.open-mobile-menu').not($(this)).removeClass('rotated'); // Reset rotation for other icons

    // Select the submenu related to this icon
    const submenu = $(this).closest('.st-mobile-menu-list').next('.st-mobile-submenu-list-block');

    // Toggle the current submenu
    submenu.slideToggle();

    // Toggle the rotation of the current icon
    $(this).toggleClass('rotated');
  });
});






document.addEventListener('DOMContentLoaded', () => {
    // Tab functionality
document.querySelectorAll('.tabs .tab').forEach((tab) => {
    tab.addEventListener('click', () => {
        // Remove 'active' class from all tabs and tab panels
        document.querySelectorAll('.tabs .tab').forEach((tab) => tab.classList.remove('active'));
        document.querySelectorAll('.tab-panel').forEach((panel) => panel.classList.remove('active'));

        // Add 'active' class to the clicked tab and corresponding panel
        tab.classList.add('active');
        const tabId = tab.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
    });
});


    // Accordion functionality
    document.querySelectorAll('.accordion-header').forEach((header) => {
        header.addEventListener('click', () => {
            const accordionItem = header.closest('.accordion-item');
            const content = accordionItem.querySelector('.accordion-content');
            const toggleIcon = header.querySelector('.accordion-toggle');

            // Toggle the 'active' class for the accordion item
            if (content.classList.contains('active')) {
                // If the content is already open, close it
                content.style.height = '0';
                content.classList.remove('active');
                accordionItem.classList.remove('active'); // Remove active class from the item
                toggleIcon.textContent = '+'; // Change to "+" when closed
            } else {
                // Close all other open accordions
                accordionItem.closest('.accordion').querySelectorAll('.accordion-item').forEach((item) => {
                    const otherContent = item.querySelector('.accordion-content');
                    const otherToggle = item.querySelector('.accordion-header .accordion-toggle');
                    if (otherContent.classList.contains('active')) {
                        otherContent.style.height = '0';
                        otherContent.classList.remove('active');
                        item.classList.remove('active'); // Remove active class from other accordion items
                        if (otherToggle) {
                            otherToggle.textContent = '+'; // Reset other buttons to "+"
                        }
                    }
                });

                // Open the clicked accordion
                content.style.height = content.scrollHeight + 'px'; // Set height based on content
                content.classList.add('active');
                accordionItem.classList.add('active'); // Add active class to the clicked accordion item
                toggleIcon.textContent = '-'; // Change to "-" when opened
            }
        });
    });
});


document.addEventListener('DOMContentLoaded', () => {
  const popupButtons = document.querySelectorAll('.open-popup');
  const popups = document.querySelectorAll('.st-board-member-content-popup-block');
  const htmlElement = document.documentElement; // Reference to the <html> element

  // Add event listener to open popup
  popupButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      // Close any open popup
      popups.forEach(popup => popup.classList.remove('active'));

      // Open the corresponding popup
      const popup = popups[index];
      if (popup) {
        popup.classList.add('active');
        htmlElement.style.overflow = 'hidden'; // Add overflow: hidden to <html>
      }
    });
  });

  // Add event listener to close popup
  popups.forEach(popup => {
    const closeButton = popup.querySelector('.close-btn');
    closeButton.addEventListener('click', () => {
      popup.classList.remove('active');
      htmlElement.style.overflow = ''; // Remove overflow: hidden from <html>
    });
  });
});




document.addEventListener('DOMContentLoaded', () => {
  const playButtons = document.querySelectorAll('.testimonial-slider-play-video');
  
  playButtons.forEach(playButton => {
    const videoContainer = playButton.closest('.testimonial-slider-video');
    const video = videoContainer.querySelector('video');
    const poster = videoContainer.querySelector('.testimonial-poster');

    if (video) {
      // Play the video and handle visibility
      playButton.addEventListener('click', () => {
        video.style.display = 'block';      // Show video
        poster.style.display = 'none';     // Hide poster
        playButton.style.display = 'none'; // Hide play button
        video.controls = true;             // Enable controls
        video.play();                      // Play video
      });

      // Pause the video and restore visibility
      video.addEventListener('pause', () => {
        video.style.display = 'none';      // Hide video
        poster.style.display = 'block';   // Show poster
        playButton.style.display = 'block'; // Show play button
        video.controls = false;           // Disable controls
      });
    }
  });
});




document.addEventListener("DOMContentLoaded", function () {
    // Select all elements with the class '.main-block-recent-slider'
    const sliders = document.querySelectorAll('.recent-news-slid-desc');
    
    if (sliders.length > 0) {
        // Get the maximum height among all sliders
        let maxHeight = 0;
        sliders.forEach(slider => {
            const sliderHeight = slider.offsetHeight;
            if (sliderHeight > maxHeight) {
                maxHeight = sliderHeight;
            }
        });

        // Apply the max height to all sliders
        sliders.forEach(slider => {
            slider.style.height = maxHeight + "px";
        });
    }
});


// Wait for the DOM to load
window.addEventListener('load', function() {
  // Get all the elements with the class 'testimonial-inner-wraper'
  const testimonialElements = document.querySelectorAll('.testimonial-inner-wraper');

  // Initialize a variable to store the maximum height
  let maxHeight = 0;

  // Loop through each testimonial element and find the maximum height
  testimonialElements.forEach(function(element) {
    const elementHeight = element.offsetHeight;
    if (elementHeight > maxHeight) {
      maxHeight = elementHeight;
    }
  });

  // Apply the maximum height to all testimonial elements
  testimonialElements.forEach(function(element) {
    element.style.height = maxHeight + 'px';
  });
});


// ============testimonial-slider==========
$(document).ready(function () {
  var $slider = $('.multiple-items');
  var slidesToShow = 3; // Default slides to show on larger screens

  // Initialize Slick slider
  $slider.slick({
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    centerMode: true, // Enables natural centering
    centerPadding: '0px', // Remove extra padding for true centering
    prevArrow: '<button type="button" class="custom-prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0705/1735/8628/files/slider-arrow-1.png?v=1736204989" alt="Previous"></button>',
    nextArrow: '<button type="button" class="custom-next-arrow"><img src="https://cdn.shopify.com/s/files/1/0705/1735/8628/files/slider-arrow-2.png?v=1736204988" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 1101,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  // Function to add center-slide class properly
  function addCenterClass() {
    $('.slick-slide').removeClass('center-slide');
    $('.slick-current').addClass('center-slide'); // Assign class to current active slide
  }

  // Run on initialization & after slide change
  $slider.on('init afterChange', function () {
    addCenterClass();
  });

  // Ensure Slick recalculates positions on resize
  $(window).on('resize', function () {
    $slider.slick('setPosition');
  });

  // Trigger Slick to properly apply the center class
  $slider.slick('refresh');
});


// =ham=


$(document).ready(function () {
  $('ul > .menu-item-has-children').append('<span class="down-arrow"><img src="./images/angle-down.svg" alt="arrow"></span>');
});


$(document).ready(function () {
  // Toggle classes for the main navigation trigger
  $(document).ready(function () {
    // Toggle the 'active' class when #navTrigger is clicked
    $('#navTrigger').click(function (e) {
      e.stopPropagation(); // Prevent the click event from propagating to the body
      $(this).toggleClass('active');
      $('#header-navlinks, #header, .nav-menu-contact, body').toggleClass('active');

      // Slide up all sub-menus and remove 'sub-menu-active' class when main nav is clicked
      $('.sub-menu').slideUp(300).removeClass('sub-menu-active');
    });

    // When clicking anywhere on the body, remove the 'active' class
    $(document).click(function (e) {
      // Check if the click was outside of the #navTrigger button
      if (!$(e.target).closest('#navTrigger').length) {
        // Remove the 'active' class from the menu
        $('#navTrigger').removeClass('active');
        $('#header-navlinks, #header, .nav-menu-contact, body').removeClass('active');
      }
    });

    // Prevent clicks inside the menu from closing the menu
    $('#header-navlinks, #header, .nav-menu-contact').click(function (e) {
      e.stopPropagation(); // Prevent event from bubbling up to the body click handler
    });
  });

  // Toggle classes for a different icon, if #nav-icon2 is used separately
  $('#nav-icon2').click(function () {
    $(this).toggleClass('open');
  });

  // Handling dropdown sub-menus
  $('.down-arrow').click(function (event) {
    event.stopPropagation(); // Prevents the event from bubbling up

    var subMenu = $(this).siblings('.sub-menu');

    // Slide toggle for the clicked sub-menu with smooth animation
    subMenu.slideToggle(300);

    // Toggle 'sub-menu-active' class for the clicked sub-menu
    subMenu.toggleClass('sub-menu-active');

    // Slide up other sub-menus and remove 'sub-menu-active' class
    $('.sub-menu').not(subMenu).slideUp(300).removeClass('sub-menu-active');
  });

  // Click event to close sub-menus when clicking outside
  $(document).click(function () {
    $('.sub-menu').slideUp(300).removeClass('sub-menu-active');
  });
});







document.addEventListener("DOMContentLoaded", () => {
  const menuLinks = document.querySelectorAll(".main-menu li.has-submenu > a");

  // Function to add or remove toggle icons based on screen size
  const updateToggleIcons = () => {
    const screenWidth = window.innerWidth;

    menuLinks.forEach(link => {
      const parentLi = link.parentElement;

      // Remove any existing toggle icons if screen width is larger than 1100px
      const existingToggleIcon = parentLi.querySelector(".toggle-icon");
      if (existingToggleIcon) {
        parentLi.removeChild(existingToggleIcon);
      }

      // Add toggle icon only if the screen width is 1100px or less
      if (screenWidth <= 1100) {
        if (!parentLi.querySelector(".toggle-icon")) {
          const toggleIcon = document.createElement("span");
          toggleIcon.classList.add("toggle-icon");
          toggleIcon.innerHTML = "+"; // Add text or styling for the toggle icon
          parentLi.appendChild(toggleIcon);

          // Add click event for the toggle icon
          toggleIcon.addEventListener("click", (e) => {
            e.stopPropagation(); // Prevent clicking the icon from triggering the anchor's behavior
            parentLi.classList.toggle("clicked");

            // Close other submenus
            document.querySelectorAll(".main-menu li.clicked").forEach(openItem => {
              if (openItem !== parentLi) {
                openItem.classList.remove("clicked");
              }
            });
          });
        }
      }
    });
  };

  // Adjust on load and resize
  updateToggleIcons();
  window.addEventListener("resize", updateToggleIcons);

  // Allow anchor links to navigate normally
  menuLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      // No additional logic needed; links will navigate as intended
    });
  });
});







// .suplement-box-content,

// ==ham-end==

window.addEventListener('DOMContentLoaded', function () {
  var divs = document.querySelectorAll('.support-incredient-content-area-inner-1 .support-incredient-content-area-inner-cards, .work-machanism-content-wrap-inner-content');
  var maxHeight = 0;

  // Find the maximum height among all divs
  divs.forEach(function (div) {
    maxHeight = Math.max(maxHeight, div.offsetHeight);
  });

  // Set the minimum height for all divs
  divs.forEach(function (div) {
    div.style.minHeight = maxHeight + 'px';
  });
});




// =======article-slider======


$('.news-article').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  prevArrow: '<button type="button" class="custom-prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0705/1735/8628/files/slider-arrow-1.svg?v=1736277783" alt="Previous"></button>',
  nextArrow: '<button type="button" class="custom-next-arrow"><img src="https://cdn.shopify.com/s/files/1/0705/1735/8628/files/slider-arrow-1.svg?v=1736277783" alt="Next"></button>',
  responsive: [
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


document.querySelectorAll('.forth-btn').forEach(button => {
  button.addEventListener('click', function (event) {
    // event.preventDefault();
    const targetSection = document.querySelector('.download-cv-sec');
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth' // Ensures smooth scrolling
      });
    }
  });
});


$(document).ready(function () {
  var windowWidth = $(window).width();

  if (windowWidth > 768 && windowWidth <= 1660) {
    var offset = jQuery('.container').offset().left;
    jQuery('.order-diana-sec .d-flex').css('padding-right', offset);

    jQuery(window).resize(function () {
      var offset = jQuery('.container').offset().left;
      jQuery('.order-diana-sec .d-flex').css('padding-right', offset);
    });
  }
});



// =======faq====== 
